import { SharedModule } from '@/app/shared/shared.module';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '@/app/core/services/user.service';
import { EnterpriseProxy, UserEnterpriseInfoViewModel } from '@/app/proxy/proxies';
import { finalize } from 'rxjs';
import { CsiHeaderState, CsiService } from './csi.service';
import { Popover } from 'primeng/popover';
import { PlantationService } from '@/app/core/services/plantation.service';
import { CsiHeaderComponent } from './shared/csi-header/csi-header.component';

interface CsiMenuItem {
  route: string;
  label: string;
  icon: string;
}

@Component({
  selector: 'app-csi',
  imports: [SharedModule, CsiHeaderComponent],
  templateUrl: './csi.component.html',
  styleUrl: './csi.component.less',
  providers: [EnterpriseProxy],
})
export class CsiComponent implements OnInit {
  headerState: CsiHeaderState = { breadcrumbs: [], header: '', description: '' };
  csiMenus: CsiMenuItem[] = [
    {
      route: 'contracts',
      label: 'doktar_app.account.enterprises.contracts',
      icon: 'ph-fill ph-signature',
    },
    {
      route: 'sub-contracts',
      label: 'doktar_app.csi.subcontracts',
      icon: 'ph ph-subtitles',
    },
    {
      route: 'milestones',
      label: 'doktar_app.csi.milestones',
      icon: 'ph-fill ph-spinner-gap',
    },
    {
      route: 'progressReport',
      label: 'doktar_app.csi.progress_report',
      icon: 'ph-fill ph-table',
    },
  ];

  defaultEnterprise: UserEnterpriseInfoViewModel = new UserEnterpriseInfoViewModel();
  allEnterprises: UserEnterpriseInfoViewModel[] = [];

  selectedEnterprise: UserEnterpriseInfoViewModel;

  enterpriseLoading = false;
  searchText: string;

  @ViewChild('opChangeEnterprise') opChangeEnterprise: Popover;
  readonly ENTERPRISE_STORAGE_KEY = 'csi_selected_enterprise_id';

  constructor(
    public router: Router,
    public userService: UserService,
    private _enterpriseProxy: EnterpriseProxy,
    public csiService: CsiService,
    private _plantationService: PlantationService
  ) { }

  ngOnInit(): void {
    this._plantationService.reset();
    this.getUserEnterprises();
    this.csiService.headerState$.subscribe((state) => {
      this.headerState = state;
    });
  }

  getUserEnterprises() {
    this.enterpriseLoading = true;
    this._enterpriseProxy.enterprise_GetUserEnterprises()
      .pipe(
        finalize(() => {
          this.enterpriseLoading = false;
        })
      )
      .subscribe((res) => {
        if (res.isSuccess) {
          const enterprises = res.result ?? [];

          const enterpriseId = localStorage.getItem(this.ENTERPRISE_STORAGE_KEY);
          let storedEnterprise;
          if (enterpriseId) {
            storedEnterprise = enterprises.find(e => e.enterpriseId === enterpriseId);
          }
          if (storedEnterprise) {
            this.selectedEnterprise = storedEnterprise;
          } else {
            this.defaultEnterprise =
              enterprises?.find((e) => e.isDefaultEnterprise) ?? new UserEnterpriseInfoViewModel();
            this.selectedEnterprise = this.defaultEnterprise;
          }

          this.csiService.selectEnterprise(this.selectedEnterprise);
          this.allEnterprises = enterprises;
        }
      });
  }

  navigateToMenu(route: string) {
    this.router.navigateByUrl('csi/' + route);
  }

  isRouteActivated(route: string) {
    const routeSlots = this.router.url.split('/');
    return routeSlots[2] === route;
  }

  selectEnterprise(selectedEnterprise: UserEnterpriseInfoViewModel) {
    this.csiService.selectEnterprise(selectedEnterprise);
    this.opChangeEnterprise.hide();
    localStorage.setItem(this.ENTERPRISE_STORAGE_KEY, selectedEnterprise.enterpriseId);

    // redirect route from contract details to contract list
    if (this.router.url.includes('/csi/contracts/')) {
      this.router.navigateByUrl('/csi/sub-contracts')
    }

    // redirect route from sub-contract details to sub-contract list
    if (this.router.url.includes('/csi/contracts/')) {
      this.router.navigateByUrl('/csi/sub-contracts')
    }
  }

  get enterpriseOptions(): UserEnterpriseInfoViewModel[] {
    if (this.searchText?.length > 1) {
      return this.allEnterprises.filter(e => e.name.toLowerCase().includes(this.searchText.toLowerCase()))
    }

    return this.allEnterprises;
  }

  get enterpriseNameAbbreviation() {
    if (!this.selectedEnterprise?.name) {
      return '';
    }
    // const defaultEnterpriseName = this.userService.currentUser?.enterprises?.[0]?.name ?? '';
    const nameSlots = this.selectedEnterprise.name.trim().split(' ');

    const first = nameSlots[0]?.[0] ?? '';
    const second = nameSlots[1]?.[0] ?? '';

    return (first + second).toUpperCase(); // Optional: make it uppercase
  }
}
